module.exports = __webpack_public_path__ + "static/media/prop-2@2x.8586f21e.webp";